var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{class:{ 'theme--blue': _vm.$route.meta.theme === 'blue' }},[_c('router-view',{attrs:{"name":"navigation"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"hero"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52aef6ad","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageHeader.vue
// module id = 906
// module chunks = 93